import { BarChart3 } from 'lucide-react'
import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@lib/permissions/guards'
import ConsultationFluxTab from '@features/stock/components/ConsultationFluxTab'

export const Route = createFileRoute('/_app/stock/consultation')({
  staticData: {
    title: 'Consultation Flux',
    icon: BarChart3,
    tab_icon: BarChart3,
    permission: 'stock.consultation.view',
    module: 'stock',
    section: 'Stock',
    order: 50,
     showInTab: true,
     showInNav: true,
     showInBreadcrumb: true,
  },
  loader: requirePermission('stock.consultation.view'),
  component: ConsultationFluxTab,
})
